import { Card, Link } from '@iwoca/orion';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import clsx from 'clsx';
import { usePhoneNumber } from 'hooks/usePhoneNumber';
import styles from './OnboardingInReviewDE.module.css';

type TReviewDocument = {
  id: string;
  title: string;
  description: string;
};

export const OnboardingInReviewDE = () => {
  const { phoneNumberLink, phoneNumber } = usePhoneNumber();

  const reviewDocuments: TReviewDocument[] = [
    {
      id: 'partnerfragebogen',
      title: t`Partner questionnaire`,
      description: t`Your completed partner questionnaire is being reviewed.`,
    },
    {
      id: 'gewerbeschein',
      title: t`Commercial register / trade licence`,
      description: t`Your trade licence is being reviewed.`,
    },
    {
      id: 'gewerbeerlaubnis',
      title: t`§34c trade permit`,
      description: t`Your §34c GewO trade permit is being reviewed.`,
    },
    {
      id: 'personalausweis',
      title: t`ID card`,
      description: t`Your ID card is being reviewed.`,
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.contents}>
        <h1 className={styles.heading}>
          <Trans>Welcome to the iwoca Partner Portal!</Trans>
        </h1>
        <p className={styles.headingDescription}>
          <Trans>
            We look forward to a successful partnership with you!
            <br />
            The portal will be unlocked as soon as the review is complete.
          </Trans>
        </p>

        <Card className={styles.card}>
          <h2 className={styles.cardHeading}>
            <Trans>Your documents are being reviewed:</Trans>
          </h2>
          <ul className={styles.docList}>
            {reviewDocuments.map((doc) => (
              <li className={styles.docRow} key={doc.id}>
                <div className={styles.docText}>
                  <h3 className={styles.docTitle}>{doc.title}</h3>
                  <p className={styles.docDescription}>{doc.description}</p>
                </div>
                <span className={styles.statusBadge}>
                  {t`Document received`}
                </span>
              </li>
            ))}
          </ul>
        </Card>

        <p
          className={clsx(styles.headingDescription, styles.contactDescription)}
        >
          <Trans>
            If you have any questions, you can contact us at any time on{' '}
            <Link
              target="_blank"
              rel="noopener noreferrer"
              href={`tel:${phoneNumberLink}`}
            >
              {phoneNumber}
            </Link>
            .
          </Trans>
        </p>
      </div>
    </div>
  );
};
